export const GOOD_ACTIVITY_INDEX_THRESHOLD = 70;
export const MEDIUM_ACTIVITY_INDEX_THRESHOLD = 40;
